<template>
    <el-card shadow="hover">
        <label slot="header">字典解析</label>
        包含缓存和store两种本地持久化方式 （建议往store注入，使用更方便）
        使用store方式，可直接使用this.$store.dispatch('JDictionary/getDictionaryByKey', 'CODE')获取字典
        <el-divider content-position="left">根据提供的字典key，获取对应值的文本code="GENDER" value="1"</el-divider>
        <j-dictionary code="GENDER" value="1"/>
        <el-divider content-position="left">单选 v-model="gender" code="GENDER" placeholder="请选择性别"</el-divider>
        <j-dictionary type="select" style="width: 200px;" v-model="gender" code="GENDER" placeholder="请选择性别" />
        <el-divider content-position="left">多选 multiple</el-divider>
        <j-dictionary type="select" style="width: 300px;" v-model="genderArr" code="GENDER" placeholder="请选择性别" multiple />

        <el-divider content-position="left">单选框模式 type="checkbox" v-model="gender" code="GENDER" placeholder="请选择性别"</el-divider>
        <j-dictionary style="width: 200px;" type="checkbox" v-model="gender" code="GENDER" placeholder="请选择性别" />
        <el-divider content-position="left">多选框模式  multiple</el-divider>
        <j-dictionary style="width: 300px;" type="checkbox" v-model="genderArr" code="GENDER" placeholder="请选择性别" multiple />
        <el-divider content-position="left">传递已有的自定义字典 :dictionary="diyDic" :props="{ key: 'num', value: 'name' }" </el-divider>
        <j-dictionary type="checkbox" style="width: 200px;" v-model="diy" placeholder="请选择" :dictionary="diyDic" :props="{ key: 'num', value: 'name' }" />
    </el-card>
</template>

<script>
    import JDictionary from "./JDictionary";
    export default {
        components: {
            JDictionary
        },
        data() {
            return {
                genderArr: [],
                gender: '',
                diy: [],
                diyDic: [
                    {  name: '测试字典项1', num: 1 },
                    {  name: '测试字典项2', num: 2 },
                    {  name: '测试字典项3', num: 3 },
                    {  name: '测试字典项4', num: 4 },
                    {  name: '测试字典项5', num: 5 }
                ]
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
